<template>
    <div class="col-12 unit-item">
        <div v-if="isLeft"
             :class="['row', 'unit-item-left', 'justify-content-center', color, {'free' : free}, {'locked' : locked}]">
            <div class="col-xl-2 order-xl-1 order-1 col-8 col-md-6">
                <div class="unit-item-cirle">
                    <!-- <div class="unit-item-circle-lesson">{{numberName}}</div> -->
                    <div class="unit-item-circle-number">{{numberText}}</div>
                </div>
            </div>
            <div class="col-xl-3 order-xl-2 unit-item-desc col-8 col-md-6 order-3 mt-2 mt-xl-0">
                <div class="unit-item-desc-title mb-3">
                    {{ title }}
                </div>
                <div class="unit-item-desc-item" v-if="lessonsCount">{{ $t('lessons_count') }}: <span>{{ lessonsCount }}</span>
                </div>
                <div class="unit-item-desc-item" v-if="time">{{ $t('pass_time') }}: <span>{{ time }}</span></div>
                <div class="unit-item-desc-item" v-if="testsCount">{{ $t('tests_count') }}: <span>{{testsCount}}</span></div>
            </div>
            <div class="col-xl-2 order-xl-3 order-2 col-4  col-md-2">
                <img :src="birdImage" class="mt-xl-5 ml-xl-n5 unit-item-bird-left-img img-z-index-2"/>
            </div>
            <div class="col-xl-5 order-xl-4 d-none d-xl-block">
            </div>
            <div class="col-xl-12 order-xl-5 mt-xl-n6 ml-xl-9 d-none d-xl-block">
                <img v-if="color === 'orange'" src="../assets/poliglotiki/images/p1-orange.png"/>
                <img v-if="color === 'green'" src="../assets/poliglotiki/images/p1-green.png"/>
                <img v-if="color === 'gray'" src="../assets/poliglotiki/images/p1-gray.png"/>
            </div>
            <div class="col-4  col-md-2 order-6 mt-xl-n6 ml-xl-6 mt-n7 ml-n5 d-block d-xl-none">
                <img v-if="color === 'orange'" src="../assets/poliglotiki/images/p3-orange.png"/>
                <img v-if="color === 'green'" src="../assets/poliglotiki/images/p3-green.png"/>
                <img v-if="color === 'gray'" src="../assets/poliglotiki/images/p3-gray.png"/>
            </div>
        </div>
        <div v-else
             :class="['row', 'unit-item-right', 'justify-content-center', 'mt-xl-n6', 'mb-xl-n4', color, {'free' : free}, {'locked' : locked}]">
            <div class="col-xl-3 offset-xl-4 unit-item-bird-right text-right order-xl-1 col-4 col-md-2 order-2">
                <img :src="birdImage" class="unit-item-bird-right-img img-z-index-2"/>
            </div>

            <div class="col-xl-2 order-xl-2 order-1 col-8 col-md-6">
                <div class="unit-item-cirle">
                    <!-- <div class="unit-item-circle-lesson">{{numberName}}</div> -->
                    <div class="unit-item-circle-number">{{numberText}}</div>
                </div>
            </div>
            <div class="col-xl-3 order-xl-3 unit-item-desc order-3 col-8 col-md-6">
                <div class="unit-item-desc-title mb-3">
                    <span>{{ title }}</span>
                </div>
                <div class="unit-item-desc-item" v-if="lessonsCount">{{ $t('lessons_count') }}: <span>{{ lessonsCount }}</span>
                </div>
                <div class="unit-item-desc-item" v-if="time">{{ $t('pass_time') }}: <span>{{ time }}</span></div>
                <div class="unit-item-desc-item" v-if="testsCount">{{ $t('tests_count') }}: <span>{{testsCount}}</span></div>
            </div>
            <div class="col-xl-12 order-xl-4 ml-xl-9 mt-xl-n6 d-none d-xl-block" v-if="!lastItem">
                <img v-if="color === 'orange'" src="../assets/poliglotiki/images/p2-orange.png"/>
                <img v-if="color === 'green'" src="../assets/poliglotiki/images/p2-green.png"/>
                <img v-if="color === 'gray'" src="../assets/poliglotiki/images/p2-gray.png"/>
            </div>
            <div class="col-4 col-md-2 order-6 mt-xl-n6 ml-xl-6 mt-n7 ml-n5 d-block d-xl-none" v-if="!lastItem">
                <img v-if="color === 'orange'" src="../assets/poliglotiki/images/p3-orange.png"/>
                <img v-if="color === 'green'" src="../assets/poliglotiki/images/p3-green.png"/>
                <img v-if="color === 'gray'" src="../assets/poliglotiki/images/p3-gray.png"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LessonListItem",
        props: {
            title: String,
            numberName: {
                type: String,
                default: 'lesson',
            },
            numberText: {
                default: '►',
            },
            number: {
                type: Number,
                required: true,
            },
            lessonsCount: String,
            time: String,
            testsCount: Number,
            color: {
                type: String,
                default: 'green',
                validator: (val) => ['green', 'orange', 'gray'].includes(val)
            },
            lastItem: {
                type: Boolean,
                default: false,
            },
            free: {
                type: Boolean,
                default: false,
            }
            ,
            locked: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            birdImage() {
                return 'poliimg/bird-' + (this.number - 1) % 8 + '.png'
            },
            isLeft() {
                return Math.abs(parseInt(this.number, 10) % 2) === 1;
            }
        },
        methods: {}
    }
</script>

<style src="@/assets/poliglotiki/main.css">
</style>
